import { getLocalStorage } from '../utils/storage/getLocalStorage'
import { REMOVE_MODULE, SET_MODULE, START_QUESTION } from './reducesTypes'

const modules = getLocalStorage('module')
export const initialModule = modules

function normalizeRules(rawRules) {
  try {
    const parsed = typeof rawRules === 'string' ? JSON.parse(rawRules) : rawRules
    console.log({ parsed })

    return {
      camera: parsed?.camera === 1 || parsed?.camera === true,
      geo: parsed?.geo === 1 || parsed?.geo === true,
    }
  } catch {
    return { camera: false, geo: false }
  }
}

export function moduleReducer(state, action) {
  switch (action.type) {
    case SET_MODULE: {
      const payload = action.payload

      return {
        ...state,
        ...payload,
        rules: normalizeRules(payload.rules),
      }
    }

    case REMOVE_MODULE:
      return {}
    case START_QUESTION:
      return {
        ...state,
        startQuestion: true,
      }
    default:
      throw Error('type not matches')
  }
}
